import { render, staticRenderFns } from "./ZnCompanyInfo.vue?vue&type=template&id=7213f0ee&"
import script from "./ZnCompanyInfo.vue?vue&type=script&lang=js&"
export * from "./ZnCompanyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports